import { render, staticRenderFns } from "./SmartReceper.vue?vue&type=template&id=70131ec3&scoped=true&"
import script from "./SmartReceper.vue?vue&type=script&lang=js&"
export * from "./SmartReceper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70131ec3",
  null
  
)

export default component.exports